 
const target_env = "DEV"
export const API_URL = "https://api.quallyhireai.com";
//export const API_URL = "http://localhost:4200";
export const APP_NAME = "QUALLYHIRE AI";
export const ITEMS_PER_PAGE = 10;
export const NUJOBS_URL = "https://nujobs.quallyhireai.com";
//export const NUJOBS_URL = "http://localhost:3000";


